<template>
    <el-dialog
        title="任务详情"
        :visible="dialogVisible"
        width="1100px"
        top="8vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="cancelDataDetail"
    >
        <!-- 内容 -->
        <div class="detail-content">
            <!-- 左侧 -->
            <div class="detail-left">
                <div class="item">站点编号：{{ drillInfo && drillInfo ? drillInfo.zdId : '-' }}</div>
                <div class="item">钻孔ID：{{ drillInfo && drillInfo ? drillInfo.zkId : '-' }}</div>
                <div class="item">行政区划：{{ drillInfo && drillInfo ? drillInfo.province+drillInfo.city+drillInfo.county+drillInfo.town : '-' }}</div>
                <div class="item">勘查经度：{{ drillInfo && drillInfo ? drillInfo.planLon : '-' }}E</div>
                <div class="item">勘查纬度：{{ drillInfo && drillInfo ? drillInfo.planLat : '-' }}N</div>
                <div class="item">实际开孔经度：{{ drillInfo && drillInfo ? (drillInfo.userInputLon != 0 ? drillInfo.userInputLon :(drillInfo.phoneLocationLon != 0 ? drillInfo.phoneLocationLon: "-") ) : '-' }}E</div>
                <div class="item">实际开孔纬度：{{ drillInfo && drillInfo ? (drillInfo.userInputLat != 0 ? drillInfo.userInputLat :(drillInfo.phoneLocationLat != 0 ? drillInfo.phoneLocationLat: "-") ) : '-' }}N</div>
                <div class="item">施工单位：{{ drillInfo && drillInfo ? drillInfo.xgdwName : '-' }}</div>
                <div class="item">施工队：{{ drillInfo && drillInfo ? drillInfo.xgdName : '-' }}</div>
                <div class="item">开孔日期：{{ drillInfo && drillInfo ? drillInfo.startDate : '-' }}</div>
                <div class="item">终孔日期：{{ drillInfo && drillInfo ? drillInfo.endDate : '-' }}</div>
                <div class="item">孔口高程：{{ drillInfo && drillInfo ? drillInfo.zkElevation : '-' }}米</div>
                <div class="item">终孔深度：{{ drillInfo && drillInfo ? drillInfo.zkHeight : '-' }}米</div>
                <div class="item">波速测试深度：{{ drillInfo && drillInfo ? drillInfo.testHeight : '-' }}米</div>
                <!-- 进场照片 -->
                <div class="item-pic">
                    <span class="title">进场照片：</span>
                    <div class="img-container" v-if="drillInfo && drillInfo.phoneJc">
                        <el-image 
                            style="width: 48px; height: 48px; margin-right: 8px; margin-bottom: 8px;"
                            v-for="(item, index) in drillInfo.phoneJc.split(',')"
                            :key="index"
                            :src="item"
                            :preview-src-list="[item]">
                        </el-image>
                    </div>
                </div>
                <!-- 开孔照片 -->
                <div class="item-pic">
                    <span class="title">开孔照片：</span>
                    <div class="img-container" v-if="drillInfo && drillInfo.phoneKk">
                        <el-image 
                            style="width: 48px; height: 48px; margin-right: 8px; margin-bottom: 8px;"
                            v-for="(item, index) in drillInfo.phoneKk.split(',')"
                            :key="index"
                            :src="item"
                            :preview-src-list="[item]">
                        </el-image>
                    </div>
                </div>
                <!-- 终孔照片 -->
                <div class="item-pic">
                    <span class="title">终孔照片：</span>
                    <div class="img-container" v-if="drillInfo && drillInfo.phoneZk">
                        <el-image 
                            style="width: 48px; height: 48px; margin-right: 8px; margin-bottom: 8px;"
                            v-for="(item, index) in drillInfo.phoneZk.split(',')"
                            :key="index"
                            :src="item"
                            :preview-src-list="[item]">
                        </el-image>
                    </div>
                </div>
                <!-- 岩芯照片： -->
                <div class="item-pic">
                    <span class="title">岩芯照片：</span>
                    <div class="img-container" v-if="drillInfo && drillInfo.phoneYx">
                        <el-image 
                            style="width: 48px; height: 48px; margin-right: 8px; margin-bottom: 8px;"
                            v-for="(item, index) in drillInfo.phoneYx.split(',')"
                            :key="index"
                            :src="item"
                            :preview-src-list="[item]">
                        </el-image>
                    </div>
                </div>
            </div>
            <!-- 分隔线 -->
            <div class="separate"></div>
            <!-- 右侧 -->
            <div class="detail-right">
                <div class="item">波速测试日期：{{ drillInfo && drillInfo.testDate ? drillInfo.testDate : '-' }}</div>
                <div class="item">波速测试方法：{{ drillInfo && drillInfo.testFun ? drillInfo.testFun : '-' }}</div>
                <div class="item">波速测量深度：{{ drillInfo && drillInfo.testHeight ? drillInfo.testHeight : '-' }}米</div>
                <!-- 波速测量工作照片 -->
                <div class="item-pic">
                    <span class="title">波速测量工作照片：</span>
                    <div class="img-container" v-if="drillInfo && drillInfo.phoneBs">
                        <el-image 
                            style="width: 48px; height: 48px; margin-right: 8px; margin-bottom: 8px;"
                            v-for="(item, index) in drillInfo.phoneBs.split(',')"
                            :key="index"
                            :src="item"
                            :preview-src-list="[item]">
                        </el-image>
                    </div>
                </div>
                <!-- 波速表格 -->
                <div class="item-table">
                    <p style="margin-bottom: 8px;">波速测试表：</p>
                    <div class="table-list">
                        <table>
                            <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
                                <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { GetDrillDetailInfo } from '@/http/api/api-hb'
export default {
    data() {
        return {
            dialogVisible: false,
            // 钻孔信息
            drillInfo: null,
            tableData: [
                ['H/m', 'Vs(m/s)', 'Vp(m/s)']
            ]
        }
    },
    methods: {
        // 显示数据详情
        showDataDetail(drillInfo) {
            // console.log(drillInfo);
            this.dialogVisible = true
            this.tableData = [
                ['H/m', 'Vs(m/s)', 'Vp(m/s)']
            ]
            this.getDrillDetailInfo(drillInfo.id)
            // this.drillInfo = drillInfo
            // if (this.drillInfo.zkBsList && this.drillInfo.zkBsList.length > 0) {
            //     this.drillInfo.zkBsList.filter(item => {
            //         let array = [item.h, item.vs, item.vp]
            //         this.tableData.push(array)
            //     })
            // }
        },
        getDrillDetailInfo(id) {
            GetDrillDetailInfo({id: id}).then(res => {
                if (res.code == 200) {
                    this.drillInfo = res.data
                    this.isShow = true
                    if (this.drillInfo.zkBsList.length > 0) {
                        this.drillInfo.zkBsList.filter(item => {
                            let array = [item.h, item.vs, item.vp]
                            this.tableData.push(array)
                        })
                    }
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 取消显示数据详情
        cancelDataDetail() {
            this.dialogVisible = false
        }
    },
}
</script>
<style scoped>
    ::v-deep .el-dialog {
        border-radius: 10px;
        height: 84vh;
    }
    ::v-deep .el-dialog .el-dialog__body {
        padding: 0 64px 20px;
        width: calc(100% - 128px);
        height: calc(100% - 74px);
    }
    ::v-deep .el-dialog__header {
        padding: 24px 40px 16px 64px;
    }
    ::v-deep .el-dialog__title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
    }
    /* 内容 */
    .detail-content {
        width: 100%;
        height: 100%;
        display: flex;
    }
    .detail-content .separate {
        width: 2px;
        height: 100%;
        background: #F5F5F5;
        border-radius: 3px;
        /* margin: 0 60px; */
    }
    .detail-content .detail-left,
    .detail-content .detail-right {
        /* width: calc(50% - 31px); */
        width: calc(50% - 31px);
        height: 100%;
        overflow: auto;
        /* background-color: #ff0; */
    }
    .detail-content .detail-left {
        padding-right: 30px;
    }
    .detail-content .detail-right {
        padding-left: 60px;
    }
    /* 左侧文字 */
    .item {
        width: 100%;
        height: 40px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #181818;
        line-height: 40px;
    }
    .item-pic {
        display: flex;
    }
    .item-pic .title {
        font-size: 16px;
        width: 114px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #181818;
        line-height: 40px;
    }
    .item-pic .img-container {
        display: flex;
    }
    /* 含照片 */
    .item-pic {
        display: flex;
        margin: 20px 0;
    }
    .item-pic .title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #181818;
        line-height: 22px;
    }
    .item-pic .img-container {
        display: flex;
        align-items: center;
        /* justify-content: space-around; */
        flex-wrap: wrap;
    }
    /* 含表格 */
    .item-table {
        width: 100%;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #181818;
        line-height: 22px;
        margin-bottom: 18px;
    }
    .item-table .table-list {
        width: 100%;
    }
    .item-table .table-list table {
        border-collapse: collapse;
        width: 100%;
    }
    .item-table .table-list table td {
        border: 1px solid #E1E1E1;
        height: 36px;
        box-sizing: border-box;
        width: 33.3%;
        text-align: center;
    }
</style>